import React, { useContext } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box } from '@mui/material';
import { ToolContext } from '../../../../../../core/context/ToolContext';

export const ReconnectAccount = ({ onConnect }) => {
    const { social_media_insight_state } = useContext(ToolContext);

    const onClose = () => {
        social_media_insight_state.showReconnectModal.set(false);
    }
    const handleConnect = () => {
        onConnect();
        onClose();
    }

    console.log("Reconnect modal: ");
    return (
        <Dialog
            open={social_media_insight_state.showReconnectModal.data}
            onClose={onClose}
            PaperProps={{
                style: {
                    borderRadius: '10px',
                    minWidth: '400px'
                }
            }}
        >
            <DialogTitle>
                <Box fontSize={20} fontWeight={600}>
                    Re-Connect {social_media_insight_state.selectedPlatform.data} Account
                </Box>
            </DialogTitle>
            <DialogContent>
                <Box fontSize={14} color="#666666" mt={1}>
                    Are you sure you want to re-connect your {social_media_insight_state.selectedPlatform.data} account? This will allow us to access your social media insights.
                </Box>
            </DialogContent>
            <DialogActions sx={{ p: 3, pt: 0 }}>
                <Button
                    variant="outlined"
                    onClick={onClose}
                    sx={{
                        mr: 2,
                        borderRadius: '10px',
                        textTransform: 'none'
                    }}
                >
                    No
                </Button>
                <Button
                    variant="contained"
                    onClick={handleConnect}
                    sx={{
                        borderRadius: '10px',
                        textTransform: 'none',
                    }}
                >
                    Yes
                </Button>
            </DialogActions>
        </Dialog>

    );
};
